import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { color } from 'styles/theme'

export const InlineSvg = styled.svg`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  color: inherit;
  fill: currentColor;
`

export const SvgWrapper = styled.div`
  display: inline-block;
  flex: 0 0 ${props => (props.size ? `${props.size}px` : '32px')};
  width: ${props => (props.size ? `${props.size}px` : '32px')};
  height: ${props => (props.size ? `${props.size}px` : '32px')};
  min-width: ${props => (props.size ? `${props.size}px` : '32px')};
  min-height: ${props => (props.size ? `${props.size}px` : '32px')};
  position: relative;
  color: inherit;
`

export const Glyph = props => {
  switch (props.glyph) {
    case 'info':
      return (
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29ZM32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z"
            fill={props.color || color.grey200}
          />
          <path
            d="M14.25 15H17.75V24H14.25V15Z"
            fill={props.color || color.grey200}
          />
          <path
            d="M18 10C18 11.1046 17.1046 12 16 12C14.8954 12 14 11.1046 14 10C14 8.89543 14.8954 8 16 8C17.1046 8 18 8.89543 18 10Z"
            fill={props.color || color.grey200}
          />
        </g>
      )
    case 'checkmark':
      return (
        <g>
          <circle
            cx="16"
            cy="16"
            fill={color.okgreen500}
            fillRule="evenodd"
            r="16"
          />
          <path
            d="m13.8955852 19.6609886 9.6241183-9.5511104 2.1132283 2.1293817-11.8181655 11.7285136-6.35717122-6.8010223 2.19163002-2.048599z"
            fill="#fff"
            fillRule="nonzero"
          />
        </g>
      )
    case 'cross':
      return (
        <g fill="none" fillRule="evenodd" transform="translate(0)">
          <circle cx="16" cy="16" fill={color.warningred500} r="16" />
          <path
            d="m13.8305474 15.9655624-4.01814379-4.0181438 2.12132039-2.12132033 4.0181437 4.01814373 4.118768-4.11876799 2.1213204 2.12132039-4.118768 4.118768 3.9567757 3.9567757-2.1213204 2.1213203-3.9567757-3.9567757-4.2056976 4.2056976-2.12132034-2.1213203z"
            fill="#fff"
            fillRule="nonzero"
          />
        </g>
      )
    case 'small-checkmark':
      return (
        <g fill="none" fillRule="evenodd">
          <path
            d="m13.9847945 19.0884462 9.6241184-9.55111041 2.1132283 2.12938161-11.8181655 11.7285136-6.35717126-6.8010223 2.19163003-2.048599z"
            fill="#fff"
          />
        </g>
      )
    case 'twitter':
      return (
        <g fill="none" fillRule="evenodd">
          <circle cx="16" cy="16" fill={props.color || color.grey200} r="16" />
          <path
            d="m22.3574998 12.1990028c.6522191-.3906147 1.1510591-1.0105812 1.390445-1.7473737-.6113657.3605123-1.28652.6235501-2.0104114.7647447-.5733794-.610649-1.3954621-.9962466-2.3021183-.9962466-1.7416398 0-3.1557367 1.4148136-3.1557367 3.1564535 0 .24942.0286689.4888059.0809898.7195911-2.6260776-.1318773-4.9496975-1.3861447-6.50785601-3.2969315-.27378866.4630039-.42788437 1.0077143-.42788437 1.5868275 0 1.0930044.5590449 2.0612989 1.40477948 2.6232107-.5181916-.0129011-1.00126374-.1576794-1.42771465-.3941984v.0387031c0 1.5302063 1.08942085 2.8074089 2.53003655 3.0991156-.2630378.070239-.5447104.1075087-.8314001.1075087-.2006828 0-.397782-.0179182-.5948811-.0551878.4035157 1.2542674 1.5674759 2.1645072 2.9486034 2.1931761-1.0808201.8457346-2.4425961 1.3474416-3.92191494 1.3474416-.25300366 0-.50170696-.0143345-.751127-.04157 1.39976244.8959053 3.05754554 1.4169638 4.84147214 1.4169638 5.8040329 0 8.9791212-4.8092196 8.9791212-8.9784044l-.0100341-.4085329c.6213999-.4465192 1.1560761-1.000547 1.5796602-1.6355647-.564062.2508535-1.1754278.4243008-1.8133123.4995568z"
            fill="#fff"
          />
        </g>
      )
    case 'facebook':
      return (
        <g fill="none" fillRule="evenodd">
          <circle cx="16" cy="16" fill={props.color || color.grey200} r="16" />
          <path
            d="m13.9300725 11.2156105v2.1495929h-1.5754525v2.6289591h1.5754525v7.8154531h3.2360645v-7.8154531h2.1715697s.2039709-1.2602246.3021792-2.6385739h-2.4600135v-1.7993398c0-.2678406.3530003-.6283953.7018799-.6283953h1.7636277v-2.73746905l-2.3995776.00000013c-3.3953954-.00068677-3.3157299 2.63101942-3.3157299 3.02522592z"
            fill="#fff"
          />
        </g>
      )
    case 'youtube':
      return (
        <g fill="none" fillRule="evenodd">
          <circle cx="16" cy="16" fill={props.color || color.grey200} r="16" />
          <path
            d="m20.9720712 9.9808233h-9.9469715c-1.94992892 0-3.53137291 1.5821513-3.53137291 3.5327875v4.9720712c0 1.9520507 1.58144399 3.5334947 3.53278741 3.5334947h9.9469716c1.9506362 0 3.5327874-1.5821513 3.5327874-3.5334947v-4.9720712c0-1.9520508-1.5828585-3.5327875-3.5334947-3.5327875zm-2.3905548 6.2607076-4.6495585 2.2186896c-.1244786.0594102-.2673461-.0311197-.2673461-.1683291v-4.5760029c0-.1393312.147111-.2298611.2708824-.1669145l4.6502657 2.3566062c.1386239.0707264.1365021.2687606-.0035363.3359507z"
            fill="#fff"
          />
        </g>
      )
    case 'external-link':
      return (
        <g fill="none" fillRule="evenodd">
          <path
            d="m14.0009183 6v2h-6.0009183v16h16v-6.0009183h2v6.0009183c0 1.1045695-.8954305 2-2 2h-16c-1.1045695 0-2-.8954305-2-2v-16c0-1.1045695.8954305-2 2-2zm7.2919749 3.29289322-3.2928932-3.29289322h8v8l-3.2928932-3.2928932-8.7071068 8.7071068-1.4142136-1.4142136z"
            fill={color.grey400}
          />
        </g>
      )
    case 'close':
      return (
        <g fill="none" fillRule="evenodd">
          {/* <rect fill={Color.grey200} height="32" rx="16" width="32" /> */}
          <path
            d="m14.5857864 16-6.99999996-7 1.41421356-1.41421356 7 6.99999996 7-6.99999996 1.4142136 1.41421356-7 7 7 7-1.4142136 1.4142136-7-7-7 7-1.41421356-1.4142136z"
            fill={color.grey700}
          />
        </g>
      )
    case 'globe':
      return (
        <g fill="none" fillRule="evenodd">
          <path
            d="m19.9660284 29.5269952c.5060873-.5823137.9979794-1.252065 1.4559155-1.9941914.5840046-.9466269 1.0896542-1.9726289 1.5130716-3.0574435h4.3294758c-.3939014.520751-.8258234 1.0183145-1.2957661 1.4880029-1.6997979 1.6988158-3.7574152 2.9094432-6.0026968 3.563632zm-15.23051967-5.0516974h4.32953831c.4234174 1.0848146.92900442 2.1108166 1.51307156 3.0574435.4579361.7421264.9498907 1.4118777 1.455978 1.9941914-2.24534411-.6541263-4.30296134-1.8648162-6.00275927-3.563632-.47006773-.4696884-.90192722-.9671894-1.2958286-1.4880029zm7.29852537-22.00223047c-.5060873.58231364-.9980419 1.25200245-1.455978 1.9941914-.58400464.94662684-1.08965419 1.97262885-1.5130716 3.05744347h-4.32947577c.39390138-.52075102.8258234-1.01831449 1.29576606-1.48800291 1.69973541-1.69881582 3.75741516-2.90950568 6.00275931-3.56363196zm15.2304572 5.05163487h-4.3294758c-.4234174-1.08481462-.9290044-2.11081663-1.5130716-3.05744347-.4579361-.74218895-.9497656-1.41187776-1.4559155-1.9941914 2.2452816.65412628 4.3028989 1.86481614 6.0026968 3.56363196.4699427.46968842.9018022.96725189 1.2957661 1.48800291zm-2.8036473 9.4258309h5.6047932c-.131634 1.9877539-.6749915 3.8953826-1.589363 5.623636h-4.9009735c.5096517-1.782566.8111279-3.6816947.8855433-5.623636zm-7.5098276 5.623636v-5.623636h5.6064191c-.0809815 1.9579413-.4108481 3.8623201-.9667124 5.623636zm0 7.1335139v-5.2323852h3.9272574c-.3172348.7231889-.6761797 1.4125028-1.0753965 2.059629-.9955405 1.6136907-2.0594307 2.6546302-2.8518609 3.1727562zm-1.9020953-5.2323852v5.2323852c-.7923677-.518126-1.8563204-1.559128-2.851861-3.1727562-.3992167-.6471262-.7581616-1.3364401-1.0753339-2.059629zm-5.60641912-7.5247647h5.60641912v5.623636h-4.6397067c-.5558018-1.7613159-.88566841-3.6656947-.96671242-5.623636zm-1.90340849-1.9010662h-5.60479323c.13163398-1.9877539.6749915-3.8953826 1.58936298-5.62363599h4.90097357c-.50965172 1.78262849-.81106538 3.68175719-.88554332 5.62363599zm7.50982761-5.62363599v5.62363599h-5.60641912c.08098147-1.9579413.41084808-3.8623201.96671242-5.62363599zm0-7.13351393v5.23238522h-3.9271949c.3171723-.72318892.6761172-1.41250276 1.0753339-2.05962903.9955406-1.61362815 2.0594933-2.65463018 2.851861-3.17275619zm1.9020953 5.23238522v-5.23238522c.7923677.51812601 1.8563204 1.55912804 2.8518609 3.17275619.3992168.64712627.7581617 1.33644011 1.0753965 2.05962903zm5.6064191 7.5247647h-5.6064191v-5.62363599h4.6397067c.5558643 1.76131589.8857309 3.66575719.9667124 5.62363599zm7.5082017 0h-5.6047932c-.074478-1.9419413-.3758916-3.84107-.8855433-5.62363599h4.9009735c.914434 1.72831589 1.457729 3.63588209 1.589363 5.62363599zm-28.13133694 1.9010662h5.60479323c.07447794 1.9419413.3758916 3.84107.88554332 5.623636h-4.90091104c-.91443401-1.7282534-1.45779153-3.6358821-1.58942551-5.623636zm30.06569974-.9505644c0-4.2713833-1.6642787-8.28714114-4.6862945-11.30752204-2.9708006-2.96925579-6.9043739-4.62582153-11.0970879-4.68119664-.0730396-.00662501-.1455165-.01125002-.2166176-.01125002-.0711636 0-.1436405.00462501-.2166802.01125002-4.192714.05531261-8.12622474 1.71187835-11.09708782 4.68113414-3.02195333 3.0204434-4.68623198 7.03620124-4.68623198 11.30758454 0 4.2714459 1.66427865 8.2872037 4.68629451 11.3075846 2.97086309 2.9692558 6.90437389 4.6258216 11.09708789 4.6811967.0730396.0066875.1455165.01125.2166801.01125.0711011 0 .143578-.004625.2166177-.01125 4.192714-.0553751 8.1262873-1.7118784 11.0970878-4.6811967 3.0219533-3.0203184 4.686232-7.0360762 4.686232-11.3075846z"
            fill={props.color || color.grey400}
            fillRule="evenodd"
          />
        </g>
      )
    case 'download':
      return (
        <path
          d="m12 3h8v9h7l-11 11-11-11h7zm-7 26v-3h22v3z"
          fill={color.grey700}
          fillRule="evenodd"
        />
      )
  }
}

Glyph.propTypes = {
  glyph: PropTypes.string.isRequired,
  color: PropTypes.string
}

class Icon extends React.Component {
  render() {
    const { size = 32, glyph, color } = this.props

    return (
      <SvgWrapper size={size} className={'icon'}>
        <InlineSvg
          fillRule="evenodd"
          clipRule="evenodd"
          strokeLinejoin="round"
          strokeMiterlimit="1.414"
          xmlns="http://www.w3.org/2000/svg"
          aria-labelledby="title"
          viewBox="0 0 32 32"
          preserveAspectRatio="xMidYMid meet"
          fit
          id={glyph}
        >
          <title id="title">{glyph}</title>
          <Glyph glyph={glyph} color={color} />
        </InlineSvg>
      </SvgWrapper>
    )
  }
}

Icon.propTypes = {
  size: PropTypes.number,
  glyph: PropTypes.string.isRequired,
  color: PropTypes.string
}

export default Icon
